import React from 'react';

import ItemFirmwarePage from '../components/ItemFirmwarePage';

const ItemFirmContainer = () => {
  return <ItemFirmwarePage />;
};

export default ItemFirmContainer;
